import { Inject, Injectable, TemplateRef } from '@angular/core';
import { Locale } from 'assets/data/locale';
import { environment } from 'environments/environment';
import { DOCUMENT } from '@angular/common';

const JSONPhone = require("../../../assets/data/phone.json");
import * as moment from 'moment-timezone';
import { Title, Meta } from '@angular/platform-browser';
import {  BehaviorSubject, map, Observable, ReplaySubject } from 'rxjs';
import { LangModel } from 'app/models/lang-model';
import { StockModel } from 'app/models/stock-model';
import { StockPromotionModel } from 'app/models/stock-promotion-model';
import { UserModel } from 'app/models/user';
import { LocationAvailableModel } from 'app/models/location-available-model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Log } from 'app/core/logging/log';



@Injectable({
  providedIn: 'root'
})
export class AppService {

    private helper = new JwtHelperService();
    public usuario: UserModel = {
        id: 0,
        name: '',
        username: '',
        email: '',
        roles: []
    };
    public static autenticado: boolean = false;
    public static langs: LangModel[] = [];
    private static langDefault: LangModel = {landId:1, name:'ES'};
    public static langSel: LangModel = AppService.langDefault;
    public cart: any[] = [];
    //public locationId?: number;
    public kiosk: string = 'MalagaCentro';
    public textosTraduccion: any = Locale.locale;
    public phone: any = JSONPhone;
    public servidor: string = environment.urlServer;
    public FORMAT_DATE: string = 'dd-MM-YYYY';
    public FORMAT_DATETIME: string = 'dd-MM-YYYY HH:mm';
    public FORMAT_DATE_SEG: string = 'dd-MM-YYYY HH:mm:ss';
    public static stockLockers:StockModel;
    toasts: any[] = [];
    public static domain:string = '';
    private currentUserSubject$: BehaviorSubject<UserModel> = new BehaviorSubject<UserModel>(null);
    public readonly currentUser$: Observable<UserModel> = this.currentUserSubject$.asObservable();

    private currentStockSubject$: ReplaySubject<StockModel> = new ReplaySubject<StockModel>(1);
    public readonly currentStock$: Observable<StockModel> = this.currentStockSubject$.asObservable();

    private currentPriceSubject$: ReplaySubject<StockPromotionModel> = new ReplaySubject<StockPromotionModel>(1);
    public readonly currentPrice$: Observable<StockPromotionModel> = this.currentPriceSubject$.asObservable();

  constructor(
    @Inject(DOCUMENT) private document: any,
    private titleService: Title,
    public meta: Meta) {
        
      AppService.langs = [
        {landId:1, name:'ES'},
        {landId:2, name:'EN'},
        {landId:3, name:'FR'},
        {landId:4, name:'DE'}
      ];

      AppService.domain = this.document.location.hostname;
      AppService.langSel = AppService.getLang();
    }

    public get tenantId(): number|null{
        return localStorage.getItem('tenant_id') ? Number(localStorage.getItem('tenant_id')) : 1;
    }

    public set tenantId(tenantId: number){
        localStorage.setItem('tenant_id', String(tenantId));
    }

    public setCurrentUser(currentUser: UserModel): void {
        this.currentUserSubject$.next(currentUser);
    }

    public setCurrentStock(currentStock: StockModel): void {
        this.currentStockSubject$.next(currentStock);
        this.currentStockSubject$.complete();
    }

    public setCurrentPrice(currentPrice: StockPromotionModel): void {
        this.currentPriceSubject$.next(currentPrice);
        //this.currentPriceSubject$.complete();
    }

    public setToken(token: string){
        localStorage.setItem('token', token);
    }
    public getToken(){
        return localStorage.getItem('token')?localStorage.getItem('token'):null;
    }
    saveOriginalToken() {
        const current = this.getToken();
        if (current) {
            localStorage.setItem('token-orign', current);
        }
    }
    restoreOriginalToken() {
        const original = localStorage.getItem('token-orign');
        if (original) {
            this.setToken(original);
            localStorage.removeItem('token-orign');
        }
    }
    isTokenExpired(token?: string): boolean {
        token ??= this.getToken() ?? undefined;
        if (!token) return false;
        return this.helper.isTokenExpired(token);
    }
    isImpersonating():boolean{
        return localStorage.getItem('token-orign')?true:false;
    }
    public static getToken() {
        return localStorage.getItem('token')?localStorage.getItem('token'):null;
    }
    public static isToken() {
        return localStorage.getItem('token')?true:false;
    }
    public static clearToken(){
        AppService.autenticado = false;
        localStorage.clear();
    }
    public set clientSelected(clientSelected: LocationAvailableModel){
        if(clientSelected != null){
            localStorage.setItem('clientSelected', JSON.stringify(clientSelected));
        } else {
            localStorage.removeItem('clientSelected');
        }
    }
    public get clientSelected(): LocationAvailableModel | null {
       try{
        const rawValue = localStorage.getItem('clientSelected');
        if(!rawValue){
            return null;
        }

        const parsed = JSON.parse(rawValue) as Partial<LocationAvailableModel>;
        return this.isValidClientSelected(parsed) ? parsed as LocationAvailableModel : null;
       }catch(e){
            console.warn(e);
            return null;
       }
    }

    public hasClientSelected(): boolean {
        return this.isValidClientSelected(this.clientSelected);
    }

    private isValidClientSelected(clientSelected: Partial<LocationAvailableModel> | null | undefined): clientSelected is LocationAvailableModel {
        return !!clientSelected
            && typeof clientSelected.locationsId === 'number'
            && clientSelected.locationsId > 0
            && typeof clientSelected.locationCode === 'string'
            && clientSelected.locationCode.length > 0;
    }

    public autenticado(){
        return AppService.autenticado;
    }
    isAdmin(): boolean{
        return AppService.autenticado && this.usuario.roles.find(i => i == 'ROLE_ADMIN') != null;
    }

    public hasRoles(allowedRoles: string[]): boolean {
        const user = this.currentUserSubject$.getValue();
        return !!user && !!user.roles && user.roles.some(rol => allowedRoles.includes(rol));
    }

    private static getLang() : LangModel{
        let lang = AppService.langs.find(f=>f.name == localStorage.getItem('lang'));
        if(lang!=undefined){
            return lang;
        }else{
            if(AppService.domain.includes('mylocker.site')){
                return AppService.langs.find(f=>f.name == 'EN');
            }else{
                return AppService.langDefault;
            }
        }
    }
    static setLang(lang: LangModel) {
        AppService.langSel = lang;
        return localStorage.setItem('lang', lang.name);
    }
    
    getTraduccion(value: string, params?: Record<string, any>): string {
        if (!value) {
            return value;
        }

        const translatedValue = this.getStaticTraduccion(value);

        return this.resolveTranslationParams(translatedValue, params);
    }

    public getLiteralTraduccion(value: any, property: string): string {
        if (!value?.literals || !property) {
            return property;
        }

        const langSel = AppService.langSel;
        const literals = value.literals[langSel.name];

        if (!literals) {
            return property;
        }

        const directMatch = literals[property];
        if (directMatch) {
            return directMatch || property;
        }

        const partialMatch = literals.find(f => f.key.toLowerCase().match(property.toLowerCase()) != null);
        if (partialMatch) {
            return partialMatch.value || property;
        }

        return property;
    }

    public getStaticTraduccion(value: string): string {
        let translatedValue = value;

        if (this.textosTraduccion) {
            if (this.textosTraduccion[AppService.langSel.name] && this.textosTraduccion[AppService.langSel.name][value]) {
                translatedValue = this.textosTraduccion[AppService.langSel.name][value];
            } else if (this.textosTraduccion['ES'] && this.textosTraduccion['ES'][value]) {
                translatedValue = this.textosTraduccion['ES'][value];
            }
        }

        return translatedValue;
    }

    private resolveTranslationParams(text: string, params?: Record<string, any>): string {
        if (!text || !params || Object.keys(params).length === 0) {
            return text;
        }

        let result = text;
        const values = Object.values(params);
        let positionalIndex = 0;

        result = result.replace(/\{([^{}]*)\}/g, (_match, key) => {
            const trimmedKey = key?.trim();

            if (!trimmedKey) {
                if (positionalIndex >= values.length) {
                    return _match;
                }

                const value = values[positionalIndex++];
                return value != null ? String(value) : '';
            }

            if (!(trimmedKey in params)) {
                return _match;
            }

            const value = params[trimmedKey];
            return value != null ? String(value) : '';
        });

        return result;
    }

	showSuccessToast(msg:string, delay:number=5000) {
		this.show(msg, { classname: 'bg-success text-light', delay: delay });
	}

	showDangerToast(msg:string, delay:number=5000) {
        this.show(msg, { classname: 'bg-danger text-light', delay: delay });
	}

    show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
        let toast = { textOrTpl, ...options };
		this.toasts.push(toast);
        setTimeout(()=>{
            this.remove(toast);
        }, toast.delay || 5000);
	}

	remove(toast) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}

    public TIMEZONE_OFFSET(){
        let now = moment.tz("Europe/Madrid");
        //console.log('now.utcOffset',now.utcOffset()/60)
        let offset = now.utcOffset()/60;
        if(offset >= 0) return "+"+offset;
        else return "-"+offset;
    }

    public setMeta(title:string, description:string, keywords:string){
        this.titleService.setTitle(title);
        this.meta.updateTag({ name: 'description', content: description });
        this.meta.updateTag({ name: 'keywords', content: keywords });

        this.meta.updateTag({ property: 'og:title', content: title });
        this.meta.updateTag({ property: 'og:type', content: 'website' });
        this.meta.updateTag({ property: 'og:image', content: 'https://www.mylocker.site/assets/img/logo-square.png' });
        this.meta.updateTag({ property: 'og:url', content: 'https://www.mylocker.site' });
        this.meta.updateTag({ property: 'og:description', content: description });
    }
    

}


